import React, { useEffect, useRef } from 'react';
import '../assets/css/Project.css';


function Projects() {
  const carouselRef = useRef(null);

  const projectImages = Array.from({ length: 55 }, (_, i) =>
    require(`../assets/images/projects/project${i + 1}.webp`)
  );

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    const speed = 1.4;

    const interval = setInterval(() => {
      carousel.scrollLeft += speed;

      if (carousel.scrollLeft >= carousel.scrollWidth / 2) {
        carousel.scrollLeft = 0;
      }
    }, 20);

    return () => clearInterval(interval);
  }, []);

  const visibleImages = projectImages.slice(0, 55);

  return (
    <section id="projects" className="projects">
      <h2 className="projects-title">Featured Projects</h2>

      <div className="carousel-wrapper">
        <div className="carousel" ref={carouselRef}>
          {[...visibleImages, ...visibleImages].map((img, index) => (
            <div className="carousel-card" key={index}>
              <img
                src={img}
                alt={`Project ${index + 1}`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
      <div style={{textAlign:'center', marginTop:'2rem'}}>
        <a
          href="https://www.facebook.com/meconsteel88co/reels/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            padding: "10px 20px",
            background: "#070089",
            color: "#fff",
            borderRadius: "5px",
            textDecoration: "none",
            fontWeight: "bold"
          }}
        >
          Watch Our Work
        </a>
      </div>
    </section>
  );
}

export default Projects;
